import { useEffect, useState } from 'react';
import { navigate } from '../app/router.ts';
import { CoverTile } from './CoverTile.tsx';
import { useItems, useProgressMap } from './hooks.ts';
import { getGroup } from '../data/catalog.ts';
import { progressFraction, stateOf } from '../data/progress.ts';
import type { CatalogGroup } from '../data/db.ts';

/** Folgenauswahl innerhalb einer Gruppe. */
export function GroupScreen({ groupId }: { groupId: string }) {
  const { items } = useItems(groupId);
  const progressMap = useProgressMap(items.length);
  const [group, setGroup] = useState<CatalogGroup | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getGroup(groupId).then((result) => {
      if (!cancelled) setGroup(result ?? null);
    });
    return () => {
      cancelled = true;
    };
  }, [groupId]);

  return (
    <div className="kids">
      <header className="kids__bar">
        <button
          type="button"
          className="iconbutton iconbutton--home"
          onClick={() => navigate('/')}
          aria-label="Zurück zur Startseite"
        >
          <span aria-hidden="true">⌂</span>
        </button>
        {group && <span className="kids__heading">{group.title}</span>}
      </header>

      <section className="grid">
        {items.map((item) => {
          const entry = progressMap.get(item.id);
          return (
            <CoverTile
              key={item.id}
              title={item.title}
              imageUrl={item.imageUrl}
              state={stateOf(entry)}
              fraction={
                entry
                  ? progressFraction(entry.trackIndex, entry.positionMs, null, entry.trackCount)
                  : 0
              }
              onClick={() => navigate(`/spielt/${item.id}`)}
            />
          );
        })}
      </section>
    </div>
  );
}
